import { CustomTable, CustomTableRef, InputDate, Combobox, formatDateTime, getFirstDayOfMonthDate, GetItemsProps, useLoader } from 'medere-ui-framework'
import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { Toast } from 'primereact/toast'
import { useState, useRef, useEffect } from 'react'
import { useIntl } from 'react-intl'
import {
  findHHMapReport,
  getAttentionStates,
  getAuditStates,
  getPatientsWithHomeHospitalizationAttentions,
  getProfessionalAttentionLogDetailReport,
  getProfessionalsAllowedToBeAssignToHomeHospitalization,
  getShowProfessionals,
  loadExternalDataGridForHomeHospitalizationReport,
  loadProfessionalAttentionLogDetail,
  loadProfessionalAttentionLogForViewHistorical,
  approveAttention,
  getCanAuditHomeHospitalization,
} from '../../servicesHooks/HomeHospitalization/useHomeHospitalizationService'
import { defaultAllComboDataDTO } from '../../dto/ComboDataDTO'
import { ProfessionalAttentionLogDTO } from '../../dto/homeHospitalization/ProfessionalAttentionLogDTO'
import AttentionReportModal from './AttentionDetailReportModal'
import { defaultProfessionalAttentionLogDetailDTO } from '../../dto/homeHospitalization/ProfessionalAttentionLogDetailDTO'
import GoogleMap from '../../components/GoogleMap'
import { AttentionMapInfo, defaultHHMapReport } from '../../dto/homeHospitalization/HHMapReport'
import { Dropdown } from 'primereact/dropdown'
import './HomeHospitalization.scss'

interface ExternalDataGrid {
  attentions: number | null
  stipulatedhonorarium: number | null
  auditedhonorarium?: number | null
}
interface AttentionState {
  id: number
  name: string
  icon: string
  color: string
}
export const defaultAttentionState: AttentionState = { id: 0, name: 'T', icon: 'T', color: '' }

export default function HomeHospitalizationReport() {
  const intl = useIntl()
  const loader = useLoader()
  const customTableRef: any = useRef<CustomTableRef>(null)
  const toast = useRef<Toast>(null)
  const externalDataGridRequestIdRef = useRef(0)
  const [downloadingReport, setDownloadingReport] = useState(false)
  const [selectedProfessionalAttentionLog, setProfessionalAttentionLog] = useState(defaultProfessionalAttentionLogDetailDTO)
  const [selectedProfessional, setSelectedProfessional] = useState(defaultAllComboDataDTO)
  const [showProfessionals, setShowProfessionals] = useState(false)
  const [canAuditHH, setCanAuditHH] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(defaultAllComboDataDTO)
  const [selectedState, setSelectedState] = useState<AttentionState>(defaultAttentionState)
  const [attentionStates, setAttentionStates] = useState<AttentionState[]>()
  const [hhMapReport, setHHMapReport] = useState(defaultHHMapReport)
  const [sinceDate, setSinceDate] = useState(getFirstDayOfMonthDate())
  const [untilDate, setUntilDate] = useState(new Date())
  const [mapVisible, setMapVisible] = useState(false)
  const [attentionDetailVisible, setAttentionDetailVisible] = useState(false)
  const [qtyAttentions, setQtyAttentions] = useState(0)
  const [totalHonorarium, setTotalHonorarium] = useState(0)
  const [auditedHonorarium, setAuditedHonorarium] = useState(0)
  const [stipulatedHonorarium, setStipulatedHonorarium] = useState(0)


  const [auditStates, setAuditStates] = useState<any[]>([])
  const [selectedAuditState, setSelectedAuditState] = useState<any>({ id: 0, name: 'Todos'});
  const [auditStateChanged, setAuditStateChanged] = useState(false);
  const [modalMode, setModalMode] = useState<'view' | 'audit' | 'editAudit'>('view');
  const isAttentionActive = (r: ProfessionalAttentionLogDTO) => !r.statedleavehour;

  useEffect(() => {
    if (!attentionDetailVisible && auditStateChanged) {
      customTableRef.current?.refreshTable();
      setAuditStateChanged(false);
    }
  }, [attentionDetailVisible, auditStateChanged]);



  useEffect(() => {
    getAuditStates().then(setAuditStates).catch(console.error)
  }, [])



  const screenHeight = window.innerHeight * 0.8

  useEffect(() => {
    if (selectedPatient && selectedPatient.id !== -1) {
      findHHMapReport(sinceDate, untilDate, selectedProfessional, selectedPatient, selectedState.id)
        .then((response) => setHHMapReport(response.data))
        .catch(console.error)
    }
  }, [sinceDate, untilDate, selectedProfessional, selectedPatient, selectedState])

  useEffect(() => {
    getShowProfessionals().then(setShowProfessionals).catch(console.error)
    getAttentionStates().then(res =>
      setAttentionStates(res.sort((a, b) => a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })))
    ).catch(console.error)
  }, [])


  const openAttentionDetailReportModal = (id: number, mode: 'view' | 'audit' | 'editAudit' = 'view') => {
    loadProfessionalAttentionLogDetail(BigInt(id) ?? BigInt(-1)).then((detail) => {
      setProfessionalAttentionLog(detail)
      setModalMode(mode)
      setAttentionDetailVisible(true)
    })
  }

  const handleDownloadReport = () => {
    setDownloadingReport(true)
    loader(
      getProfessionalAttentionLogDetailReport({
        from: sinceDate,
        patient: selectedPatient,
        professional: selectedProfessional,
        to: untilDate,
        state: selectedState.id
      })
        .catch(console.error)
        .finally(() => setDownloadingReport(false))
    )
  }

  useEffect(() => {
    getCanAuditHomeHospitalization()
        .then(v => {
          setCanAuditHH(v);
    })
        .catch(console.error)
  }, []);

  function getIconFromAttention(attention: AttentionMapInfo) {
    let icon = 'http://maps.google.com/mapfiles/ms/icons'
    icon += attention.validated ? '/green' : '/red'
    if (attention.isarrival) icon += '-dot'
    return icon + '.png'
  }

  const handleApproveAttention = async (row: ProfessionalAttentionLogDTO) => {
    try {
      await approveAttention(Number(row.professionalattentionlog))
      
      customTableRef.current?.updateRow?.(row);
      
      toast.current?.show({
        severity: 'success',
        summary: 'Éxito',
        detail: 'Atención aprobada exitosamente',
        life: 3000
      })

      customTableRef.current?.refreshTable?.();
      
    } catch (error) {
      console.error('Error al aprobar la atención:', error)
      
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo aprobar la atención',
        life: 3000
      })
    }
  }

  useEffect(() => {
    getAuditStates().then(res =>
      setAuditStates(res.sort((a, b) => a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })))
    ).catch(console.error)
  }, [])

  useEffect(() => {
    if (customTableRef.current?.refresh) {
      customTableRef.current?.refreshTable()
    }
  }, [selectedAuditState])


  useEffect(() => {
    if (!attentionDetailVisible && auditStateChanged) {
      customTableRef.current?.refreshTable();
      setAuditStateChanged(false);
    }
  }, [attentionDetailVisible, auditStateChanged]);


  return (
    <div className='home-hospitalization-report px-4 flex flex-column viewContainer'>
      <div className='flex justify-content-between align-items-center'>
        <h2 className='text-2xl mainTitle'>{"Reporte de atenciones a domicilio"}</h2>
        <div className='flex gap-2'>
          {(selectedPatient && selectedPatient.id !== -1 && hhMapReport.patient != null) && (
            <Button icon='pi pi-map' label={mapVisible ? intl.formatMessage({ id: 'HideMap' }) : intl.formatMessage({ id: 'ViewOnMap' })} iconPos='right' className='buttonMain3' onClick={() => setMapVisible(!mapVisible)} />
          )}
          <Button icon='pi pi-download' label={intl.formatMessage({ id: 'Download' })} iconPos='right' className='buttonMain3'
            disabled={downloadingReport} onClick={handleDownloadReport} />
        </div>
      </div>

      <div className='flex w-full gap-3 my-3 items-stretch'>
        <div className='px-3 py-2 border-round-md flex justify-content-between align-items-center flex-1 gap-4 shadow-1 border-1'>
          <div className='flex flex-column flex-grow'>
            <h3 className='text-xl text-gray-500'>{intl.formatMessage({ id: 'Attentions' })}</h3>
            <span className='flex justify-content-between align-items-center'>
              <h3 className='text-xl text-black font-semibold'>{qtyAttentions} {intl.formatMessage({ id: 'Attentions2' })}</h3>
            </span>
          </div>
          <i className='pi pi-search text-xl font-semibold bg-home-hosp-accent p-2 border-round'></i>
        </div>

        <div className='px-3 py-2 rounded-md shadow border-1 flex-1 flex items-center justify-between gap-4'>
          <div className='flex flex-col'>
            <h3 className='text-xl text-gray-500'>{showProfessionals ? 'Honorarios' : 'Auditados'}</h3>
            <h3 className='text-xl text-black font-semibold'>
              $ {(showProfessionals ? totalHonorarium : auditedHonorarium).toLocaleString('es-AR', { maximumFractionDigits: 0 })}
            </h3>
          </div>

          <div className='self-center text-right text-sm leading-5 text-home-hosp-accent'>
            <div className='mb-1'>
              <span className='mr-1'>{showProfessionals ? 'Auditados:' : 'Honorarios:'}</span>
              <span>$ {(showProfessionals ? auditedHonorarium : totalHonorarium).toLocaleString('es-AR', { maximumFractionDigits: 0 })}</span>
            </div>
            <div>
              <span className='mr-1'>Pendientes:</span>
              <span>$ {stipulatedHonorarium ? stipulatedHonorarium.toLocaleString('es-AR', { maximumFractionDigits: 0 }) : '0'}</span>
            </div>
          </div>

          <i className='pi pi-dollar text-xl font-semibold bg-home-hosp-accent p-2 border-round'></i>
        </div>

      </div>

      {(selectedPatient && selectedPatient.id !== -1 && hhMapReport.patient != null && mapVisible) && (
        <div>
          <GoogleMap
            center={{ lat: hhMapReport.patient.latitude, long: hhMapReport.patient.longitude }}
            zoom={15}
            mainMarker={{ id: 1, position: { lat: hhMapReport.patient.latitude, long: hhMapReport.patient.longitude }, icon: 'http://maps.gstatic.com/mapfiles/ms2/micons/rangerstation.png', title: hhMapReport.patient.description }}
            otherMarkers={hhMapReport.attentions.map((a) => ({ id: a.professionalattentionlog, position: { lat: a.latitude, long: a.longitude }, icon: getIconFromAttention(a), title: (a.description + ', ' + formatDateTime(a.statedhour)) }))}
            onClickOtherMarkers={(id: number) => openAttentionDetailReportModal(id, 'view')}
          />
          <label className='text-center text-sm font-italic'>{intl.formatMessage({ id: 'DataFromApril2024Onwards' })}</label>
        </div>
      )}

      <CustomTable
        idTable='homeHospitalizationReportTable'
        getItems={(offset: number, pageSize: number, params: any) => {
          const requestId = ++externalDataGridRequestIdRef.current
          return loadProfessionalAttentionLogForViewHistorical(offset, pageSize, params)
            .then((response) => {
              if (requestId === externalDataGridRequestIdRef.current) {
                loadExternalDataGridForHomeHospitalizationReport(params)
                  .then((ext: ExternalDataGrid) => {
                    if (requestId === externalDataGridRequestIdRef.current) {
                      setQtyAttentions(ext.attentions || 0)
                      setStipulatedHonorarium(ext.stipulatedhonorarium || 0)
                      setAuditedHonorarium(ext.auditedhonorarium || 0)
                      setTotalHonorarium((ext.stipulatedhonorarium || 0) + (ext.auditedhonorarium || 0))
                    }
                  }).catch(console.error)
              }
              return response
            }).catch(console.error)
        }}
        hideFiltersButton
        minHeight={screenHeight}
        className='crudTable'
        ref={customTableRef}
        params={{
          from: sinceDate,
          to: untilDate,
          professional: selectedProfessional,
          patient: selectedPatient,
          showProfessionals: showProfessionals,
          state: selectedState.id,
          auditState: selectedAuditState.id
        }}
        buttonController
        buttonControllerLeft
        rowButtonClassName=''
        dropdownExtraButtons={
          canAuditHH
            ? [
                {
                  text: 'Aprobar',
                  icon: 'pi pi-check',
                  onClick: (r: ProfessionalAttentionLogDTO) => handleApproveAttention(r),
                  showWhen: (r: ProfessionalAttentionLogDTO) =>
                    !isAttentionActive(r) &&
                    r.auditstate === 3 || r.auditstate === 2 || r.auditstate === 4 // Pendiente / Observado / Anulado
                },
                {
                  text: 'Auditar',
                  icon: 'pi pi-list',
                  onClick: (r: ProfessionalAttentionLogDTO) =>
                    openAttentionDetailReportModal(Number(r.professionalattentionlog), 'audit'),
                  showWhen: (r: ProfessionalAttentionLogDTO) => !isAttentionActive(r) && r.auditstate === 3 // Pendiente
                },
                {
                  text: 'Editar auditoría',
                  icon: 'pi pi-pencil',
                  onClick: (r: ProfessionalAttentionLogDTO) =>
                    openAttentionDetailReportModal(Number(r.professionalattentionlog), 'editAudit'),
                  showWhen: (r: ProfessionalAttentionLogDTO) => !isAttentionActive(r) && (r.auditstate === 1 || r.auditstate === 2 || r.auditstate === 4) // Aprobado / Observado / Anulado
                },
                {
                  text: 'Ver detalle',
                  icon: 'pi pi-eye',
                  onClick: (r: ProfessionalAttentionLogDTO) =>
                    openAttentionDetailReportModal(Number(r.professionalattentionlog), 'view'),
                  showWhen: () => true
                }
              ]
            : [
                {
                  text: 'Ver detalle',
                  icon: 'pi pi-eye',
                  onClick: (r: ProfessionalAttentionLogDTO) =>
                    openAttentionDetailReportModal(Number(r.professionalattentionlog), 'view')
                }
              ]
        }
      >
        <Column
          field='professionalname'
          header={intl.formatMessage({ id: 'Professional' })}
          className='text-left'
          body={(r: ProfessionalAttentionLogDTO) => <div className='text-left'>{r.professionalname}</div>}
          filter
          filterElement={showProfessionals && (
            <div className='tbl-filter'>
            <Combobox
              getItems={({ filterValue = '', offSet = 0, pageSize = 0 }: GetItemsProps) =>
                getProfessionalsAllowedToBeAssignToHomeHospitalization(filterValue, offSet, pageSize).then((res: any) => [defaultAllComboDataDTO, ...res.sort((a: any, b:any) => a.name.localeCompare(b.name, 'es', { sensitivity: 'base' }))])
              }
              optionLabel='name'
              setValue={setSelectedProfessional}
              value={selectedProfessional}
              placeholder={intl.formatMessage({ id: '<All>' })}
              minPanelWidth={300}
              maxPanelWidth={400}
            />
            </div>
          )}
        />

        <Column
          field='patientname'
          header={intl.formatMessage({ id: 'Patient' })}
          className='text-left'
          body={(pal: ProfessionalAttentionLogDTO) => <div className='text-left'>{pal.patientname}</div>}
          filter
          filterElement={
            <Combobox
              getItems={({ filterValue = '', offSet = 0, pageSize = 0 }: GetItemsProps) =>
                getPatientsWithHomeHospitalizationAttentions(filterValue, offSet, pageSize).then((res: any) => [defaultAllComboDataDTO, ...res.sort((a: any, b:any) => a.name.localeCompare(b.name, 'es', { sensitivity: 'base' }))])
              }
              optionLabel='name'
              setValue={setSelectedPatient}
              value={selectedPatient}
              placeholder={intl.formatMessage({ id: '<All>' })}
              minPanelWidth={300}
              maxPanelWidth={400}
            />
          }
        />

        <Column
          field='statedarrivalhour'
          header='Fecha de atención'
          className='text-center columnDateTime nowrap'
          headerClassName='th-no-wrap text-left'
          style={{minWidth: 255}}
          body={(r) => formatDateTime(r.statedarrivalhour)}
          filter
          filterElement={
            <div className='date-range-inline date-compact-balanced'>
              <InputDate value={sinceDate} onChange={(e)=>setSinceDate(e.value)} />
              <InputDate value={untilDate} onChange={(e)=>setUntilDate(e.value)} />
            </div>
          }
        />

        <Column field='duration' header='Duración' className='text-left nowrap' style={{width: 100, minWidth: 100}}
          body={(r) => <b>{r.duration ? `${r.duration?.length==4?'0'+r.duration:r.duration} min` : intl.formatMessage({id:'Active'})}</b>}
        />


        <Column field='value' header='Honorarios' className='text-center nowrap' headerClassName='text-left' style={{width: 90, minWidth: 90}}
          body={(r) => <span className='money'>$ {r.totalhonorarium ? r.totalhonorarium.toLocaleString('es-AR',{maximumFractionDigits:0}) : '0'}</span>}
        />

        <Column
          header="Registros"
          className="text-center nowrap"
          filter
          filterElement={
            <div className="tbl-filter">
              <Dropdown
                value={selectedState}
                optionLabel="name"
                options={attentionStates}
                onChange={(e) => setSelectedState(e.value)}
                placeholder='<Todos>'
              />
            </div>
          }
          body={(r: ProfessionalAttentionLogDTO) => (
            <div className="row-actions inline">
              <i
                className={`pi pi-clock icon-custom ${r.validtime ? 'green' : 'orange'}`}
              />
              <i
                className={`pi pi-map-marker icon-custom ${r.validlocation ? 'green' : 'orange'}`}
              />
            </div>
          )}
        />

        <Column
          header="Auditoría"
          className="text-center nowrap"
          filter
          filterElement={
            <div className="tbl-filter">
              <Dropdown
                value={selectedAuditState}
                options={auditStates}
                optionLabel="name"
                onChange={(e) => setSelectedAuditState(e.value)}
                placeholder="<Todos>"
              />
            </div>
          }
          body={(r: any) => {
            const state = auditStates.find(a => a.id === r.auditstate);

            if (!state || state.id === 0) return null;

            return (
              <span className={`audit-pill ${state.color}`}>
                {state.name}
              </span>
            );
          }}
        />


      </CustomTable>

      <AttentionReportModal 
        visible={attentionDetailVisible} 
        setVisible={setAttentionDetailVisible} 
        data={selectedProfessionalAttentionLog} 
        showHonorarium={showProfessionals}
        onAuditStateUpdated={() => {
          setAuditStateChanged(true)} 
        }
        mode={modalMode}
      />
      
      <Toast ref={toast} />
    </div>
  )
}
